import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-11ec62e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "loading"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loading-img"
}, [/*#__PURE__*/_createElementVNode("svg", {
  viewBox: "25 25 50 50"
}, [/*#__PURE__*/_createElementVNode("circle", {
  r: "20",
  cy: "50",
  cx: "50"
})]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#fff",
    "font-size": "13px",
    "margin-top": "5px"
  }
}, "加载中...")], -1));
const _hoisted_3 = [_hoisted_2];
export default {
  __name: 'loading',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return __props.show ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3)) : _createCommentVNode("", true);
    };
  }
};